module.exports = __webpack_public_path__ + "static/googleplay-c581a7c5eae7689a6baffd9f0d28f694.svg";